<template>
  <ul class="keywords">
    <li v-for="item in keywords" :key="item.id">
      <router-link :to="item.path" class="keywords_link">
        {{ item.name }}
      </router-link>
    </li>
  </ul>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'
import { useSpecial } from '@/provider/special'
export default defineComponent({
  name: 'Keywords',
  props: {
    ids: {
      type: Array as PropType<number[]>,
      default: null
    }
  },
  setup(props) {
    const { state, loadKeywords } = useSpecial()
    if (!state.keywords.length) loadKeywords()

    const keywords = computed(() =>
      state.keywords.filter((val, index) =>
        props.ids ? props.ids.includes(val.id) : index < 100
      )
    )
    return {
      keywords
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.keywords {
  display: flex;
  flex-wrap: wrap;
  line-height: 1;
  padding: 20px 0;
  margin-top: -16px;
  > li {
    margin-right: 16px;
    margin-top: 16px;
  }
  @include mixins.media() {
    padding: 20px 16px;
  }
}

.keywords_link {
  display: inline-block;
  padding: 15px 17px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #e4e4e4;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  font-weight: 500;
  font-size: 13px;
  letter-spacing: 0.03em;
  line-height: 1.46;
}
</style>
